import React, { useState } from 'react';
import * as Icons from 'react-feather';

const FiltreDossier = ({ isOpen, onClose, onApplyFilters }) => {
    const [statut, setStatut] = useState('');
    const [type, setType] = useState('');
    const [juridiction, setJuridiction] = useState('');

    const handleReset = () => {
        setStatut('');
        setType('');
        setJuridiction('');
    };

    const handleApplyFilters = () => {
        onApplyFilters({
            statut,
            type,
            juridiction
        });
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-transparent z-50 flex justify-end backdrop-filter backdrop-blur-sm">
            <div
                className={`bg-white w-full max-w-md h-full overflow-y-auto transform transition-transform duration-300 shadow-xl ${isOpen ? 'translate-x-0' : 'translate-x-full'
                    }`}
            >
                <div className="p-6 border-b border-gray-200">
                    <div className="flex justify-between items-center">
                        <h2 className="text-xl font-bold text-gray-900">Filtres</h2>
                        <button
                            onClick={onClose}
                            className="text-gray-500 hover:text-gray-900 p-2 rounded-full hover:bg-gray-100 transition-colors"
                        >
                            <Icons.X size={24} />
                        </button>
                    </div>
                    <p className="text-gray-600 mt-2">
                        Affinez la liste des dossiers selon vos critères
                    </p>
                </div>

                {/* Contenu des filtres */}
                <div className="p-6 bg-gray-50 h-full">
                    <div className="space-y-6">
                        {/* Filtre par statut */}
                        <div>
                            <label className="block text-gray-700 font-medium mb-2">Statut</label>
                            <div className="relative">
                                <select
                                    value={statut}
                                    onChange={(e) => setStatut(e.target.value)}
                                    className="w-full border border-gray-300 rounded-lg py-2 px-3 text-gray-700 appearance-none focus:outline-none focus:ring-2 focus:ring-gray-200"
                                >
                                    <option value="">Tous les statuts</option>
                                    <option value="En cours">En cours</option>
                                    <option value="En attente">En attente</option>
                                    <option value="Complété">Complété</option>
                                </select>
                                <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                                    <Icons.ChevronDown className="text-gray-500" size={20} />
                                </div>
                            </div>
                        </div>

                        {/* Filtre par type de dossier */}
                        <div>
                            <label className="block text-gray-700 font-medium mb-2">Type de dossier</label>
                            <div className="relative">
                                <select
                                    value={type}
                                    onChange={(e) => setType(e.target.value)}
                                    className="w-full border border-gray-300 rounded-lg py-2 px-3 text-gray-700 appearance-none focus:outline-none focus:ring-2 focus:ring-gray-200"
                                >
                                    <option value="">Tous les types</option>
                                    <option value="Personne Physique">Personne Physique</option>
                                    <option value="Personne Morale">Personne Morale</option>
                                </select>
                                <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                                    <Icons.ChevronDown className="text-gray-500" size={20} />
                                </div>
                            </div>
                        </div>

                        {/* Filtre par juridiction */}
                        <div>
                            <label className="block text-gray-700 font-medium mb-2">Juridiction</label>
                            <div className="relative">
                                <select
                                    value={juridiction}
                                    onChange={(e) => setJuridiction(e.target.value)}
                                    className="w-full border border-gray-300 rounded-lg py-2 px-3 text-gray-700 appearance-none focus:outline-none focus:ring-2 focus:ring-gray-200"
                                >
                                    <option value="">Toutes les juridictions</option>
                                    <option value="Abidjan">Abidjan</option>
                                    <option value="San Pedro">San Pedro</option>
                                    <option value="Bouaké">Bouaké</option>
                                    <option value="Daloa">Daloa</option>
                                </select>
                                <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                                    <Icons.ChevronDown className="text-gray-500" size={20} />
                                </div>
                            </div>
                        </div>

                        {/* Boutons d'action */}
                        <div className="flex space-x-4 mt-12">
                            <button
                                onClick={handleReset}
                                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
                            >
                                Réinitialiser
                            </button>
                            <button
                                onClick={handleApplyFilters}
                                className="flex-1 px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-600"
                            >
                                Appliquer les filtres
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FiltreDossier;